<div class="embed-responsive embed-responsive-16by9 h-100 w-100">
  <atx-picture-in-picture
    [activate]="pipActive"
    (exitPip)="exitPictureInPicture()"
  >
    <div class="embed-responsive-item" #vimeoPlayerTpl></div>
  </atx-picture-in-picture>
</div>
